import { dataListChecked } from 'dls-icons-data'
import { createIcon } from '../common'

const IconListChecked = /*#__PURE__*/createIcon(dataListChecked)
export default IconListChecked
